import { render, staticRenderFns } from "./ProxiesUdp.vue?vue&type=template&id=c2219320&"
import script from "./ProxiesUdp.vue?vue&type=script&lang=js&"
export * from "./ProxiesUdp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports